import React from 'react';
import { Link } from 'react-router-dom';
import { tickerFacts } from '../../data/populations';
import { useScenario } from '../../contexts/ScenarioContext';
import { SourceRef } from '../SourceRef';
import { UtcClock } from './UtcClock';
import { ThemeSwitcher } from './ThemeSwitcher';
export function Ticker() {
  const {
    scenario
  } = useScenario();
  const loop = [...tickerFacts, ...tickerFacts];
  return <div className="relative h-8 overflow-hidden border-b border-line bg-surface" data-id="element-263" data-mp="o5agzltjf2w">
      <div className="absolute left-0 top-0 z-10 flex h-full items-center gap-2 border-r border-line bg-surface px-3 font-mono text-[10px] uppercase tracking-wider text-machine" data-id="element-264" data-mp="5loru8dtc7z2">
        <span className="h-1.5 w-1.5 rounded-full bg-machine" aria-hidden="true" data-id="element-265" data-mp="emmvgpkcadh4" />
        Wire
      </div>
      <ul className="census-marquee flex h-full w-max items-center pl-24" aria-label="Sourced facts" data-id="element-266" data-mp="1m0q7i14md8ad">
        {loop.map((f, i) => <li key={i} className="flex items-center whitespace-nowrap px-6 font-mono text-[11.5px] text-muted" aria-hidden={i >= tickerFacts.length} data-id="element-267" data-mp="1q0qmbmvmrlhy" data-mpi={i}>
            <span className="text-ink/85" data-id="element-268" data-mp="20rk9jmziyfj5">{f.text}</span>
            <SourceRef id={f.sourceId} data-id="element-269" data-mp="20s3iie775tl1" />
            <span className="ml-6 text-faint" aria-hidden="true" data-id="element-270" data-mp="1vsh25vw2nx80">
              /
            </span>
          </li>)}
      </ul>
      <div className="absolute right-0 top-0 z-10 flex h-full items-center gap-4 border-l border-line bg-surface px-3" data-id="element-271" data-mp="1rpu7zobxi07n">
        <Link to="/" className="hidden whitespace-nowrap font-mono text-[11px] text-muted hover:text-ink sm:inline" title="Active scenario — change it on the Census page" data-id="element-272" data-mp="1mtdkmwcjzpvm">
          Scenario <span className="text-machine" data-id="element-273" data-mp="1d311n8ke04rl">{scenario.label}</span>
        </Link>
        <UtcClock data-id="element-274" data-mp="183eo0y0ncmi9" />
        <ThemeSwitcher data-id="element-275" data-mp="183xv1jordqhi" />
      </div>
    </div>;
}